import { render, staticRenderFns } from "./StuAwards.vue?vue&type=template&id=7b2888ba&scoped=true&"
import script from "./StuAwards.vue?vue&type=script&lang=js&"
export * from "./StuAwards.vue?vue&type=script&lang=js&"
import style0 from "./StuAwards.vue?vue&type=style&index=0&id=7b2888ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2888ba",
  null
  
)

export default component.exports